(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["jw-client-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jwc-client-gallery')) {
  customElements.define('jwc-client-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
      this.thumbnailTrack = this.querySelector('[data-gallery-thumbnails]');
      this.counter = this.querySelector('[data-gallery-count]');
      this.index = 0;
      if (!this.track || !this.slides.length) return;
      this.querySelectorAll('.jwc-gallery-arrow').forEach(button => { button.hidden = this.slides.length < 2; });
      this.querySelector('[data-gallery-prev]').addEventListener('click', () => this.select(this.index - 1));
      this.querySelector('[data-gallery-next]').addEventListener('click', () => this.select(this.index + 1));
      this.thumbnails.forEach((thumbnail, index) => thumbnail.addEventListener('click', event => {
        event.preventDefault();
        this.select(index);
      }));
      this.track.addEventListener('keydown', event => {
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault();
        this.select(targets[event.key]);
      });
      this.track.addEventListener('scroll', () => {
        if (this.scrollPending) return;
        this.scrollPending = true;
        requestAnimationFrame(() => {
          this.scrollPending = false;
          const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (index !== this.index && index >= 0 && index < this.slides.length) this.update(index);
        });
      }, { passive: true });
      this.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) this.select(index);
      });
    }
    select(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior });
    }
    update(index) {
      this.index = index;
      this.thumbnails.forEach((thumbnail, position) => {
        if (position === index) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
      this.counter.textContent = `${index + 1} / ${this.slides.length}`;
      const thumbnail = this.thumbnails[index];
      const left = thumbnail.offsetLeft - (this.thumbnailTrack.clientWidth - thumbnail.offsetWidth) / 2;
      this.thumbnailTrack.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
